import { Guid } from '@web/utils';

export class WarehouseSkuUsageProduct {
  public constructor(
    private readonly data: {
      id: Guid;
      name: string;
    },
  ) {}

  public get id(): string {
    return this.data.id;
  }

  public get name(): string {
    return this.data.name;
  }
}
